import { useTranslation } from 'react-i18next';
import { shallow } from 'zustand/shallow';

import { NOT_APPLICABLE_STRING } from '../../../../constants/general';
import { IconType, Icons } from '../../../../constants/icons';
import { SpaceMembershipRole } from '../../../../constants/space';
import {
  Audience,
  Post,
  PostContentType,
  PostState,
} from '../../../../models/PostStore/Post';
import {
  SpaceMembership,
  SpaceMembershipState,
} from '../../../../models/SpaceStore';
import { Album } from '../../../../models/SpaceStore/Album';
import { Space } from '../../../../models/SpaceStore/Space';
import { Profile } from '../../../../models/UserStore/Profile';
import { useSpaceStore } from '../../../../stores/SpaceStore';
import { PostView, PostViewProps } from '../../../Molecules';

export type PostTemplateProps = {
  post: Post | null | undefined;
  creator: PostViewProps['creator'];

  classroom: Space | null | undefined;
  album: Album | null | undefined;
  albumClassroom: Space | null | undefined;
  membership: SpaceMembership | null | undefined;

  sharingSpace: Space | null | undefined;
  sharingSpaceOwner: Profile | null | undefined;

  sharingUser: Profile | null | undefined;
  postFailedFetch: boolean;
};

export const PostTemplate = (props: PostTemplateProps) => {
  const {
    post,
    creator,
    classroom,

    album,
    albumClassroom,
    membership,

    sharingSpace,
    sharingSpaceOwner,

    sharingUser,
    postFailedFetch,
  } = props;
  const { t } = useTranslation();
  ``;

  // post visibility
  const isPostAvailable = post?.state == PostState.Available;
  const isPublic = post?.audience == Audience.Public;
  const isMemberOnly =
    post?.audience == Audience.Members &&
    membership?.state == SpaceMembershipState.InGroup;
  const isTierContent =
    Array.isArray(post?.audience) &&
    membership?.tier?.tierId &&
    post?.audience.includes(membership.tier.tierId);
  const isRootAdmin =
    membership?.role !== undefined &&
    [SpaceMembershipRole.Admin, SpaceMembershipRole.Root].includes(
      membership.role,
    );
  const allowDisplay =
    isPostAvailable &&
    (isPublic || isMemberOnly || isTierContent || isRootAdmin) &&
    !postFailedFetch;

  const postMultiplayerGame = useSpaceStore((store) => {
    return store.getMultiplayerGame(
      post?.content.type == PostContentType.MultiplayerGame
        ? post.content.multiplayerGameId
        : NOT_APPLICABLE_STRING,
    );
  }, shallow);

  return (
    <>
      <div
        className="flex flex-col"
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          padding: '1rem',
        }}
      >
        {allowDisplay ? (
          <>
            <PostView
              post={post}
              creator={creator}
              classroom={classroom}
              album={album}
              albumClassroom={albumClassroom}
              membership={membership}
              //

              sharingSpace={sharingSpace}
              sharingSpaceOwner={sharingSpaceOwner}
              //
              sharingUser={sharingUser}
              sharingMultiplayerGame={postMultiplayerGame}
            />
          </>
        ) : (
          <div className="post unselectable">
            <div
              className="flex flex-col gap-1 bg-gray-150"
              style={{ padding: '1rem', margin: '1rem', borderRadius: '1rem' }}
            >
              <div className="flex items-center gap-1">
                <img
                  className="size-icon-m"
                  src={Icons[IconType.ReportProblem]}
                />
                <p className="text-md">
                  {t('Sorry, this content isn’t available at the moment.')}
                </p>
              </div>

              <p className="text-gray-600 text-sm">
                {t(
                  'When this happens, it’s usually because the owner only shared it with a small group of people, changed who can see or it’s been deleted.',
                )}
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
